import {stringify} from "query-string";
import {SERVER} from "../constants";
import {MAP_URL} from "../constants/urls";
import {HttpClient} from "../utils/requests";
import {blogCategoryMapperListResponse} from "../panels/blogCategory/blogCategoryMapper";
import {adviceListResponse} from "../panels/advice/adviceMapper";
import {blogMapperListResponse} from "../panels/blog/blogMapper";
import {userMapperListResponse} from "../panels/user/userMapper";
import {configMapperListResponse} from "../panels/config/configMapper";
import {periodMapperListResponse} from "../panels/period/periodMapper";
import {codesMapperListResponse} from "../panels/codes/codeMapper";
import {forumCategoryMapperListResponse} from "../panels/forumCategory/forumCategoryMapper";
import {forumMapperListResponse} from "../panels/forum/forumMapper";
import {reportMapperListResponse} from "../panels/report/reportMapper";
import {specialistCardMapperListResponse} from "../panels/specialistCard/specialistCardMapper";
import {specialistCommentListResponse} from "../panels/specialistComment/specialistCommentMapper";
import {invoiceMapperListResponse} from "../panels/invoice/invoiceMapper";
import {adminLogHistoryMapperListResponse} from "../panels/adminLogHistory/adminLogHistoryMapper";
import {userConversationListResponse} from "../panels/userConversation/userConversationMapper";
import {attachmentMapperListResponse} from "../panels/attachment/attachmentMapper";
import {conversationMapperListResponse} from "../panels/conversation/conversationMapper";
import {messageMapperListResponse} from "../panels/message/messageMapper";
import {specialistSalesReportListResponse} from "../panels/specialistSalesReport/specialistSalesReportMapper";
import {specialistTransactionListResponse} from "../panels/specialistTransaction/specialistTransactionMapper";
import {conversationAdMapperListResponse} from "../panels/conversationAd/conversationAdMapper";
import {avatarMapperListResponse} from "../panels/avatar/avatarMapper";
import {experimentMapperListResponse} from "../panels/experiment/experimentMapper";
import {userVariantMapperListResponse} from "../panels/userVariant/userVariantMapper";
import {variantMapperListResponse} from "../panels/variant/variantMapper";
import {childWeekMapperListResponse} from "../panels/childWeek/childWeekMapper";
import {marketLoginListResponse} from "../panels/marketLogin/marketLoginMapper";
import {welcomeModalListResponse} from "../panels/welcomeModal/welcomeModalMapper";
import {termsConditionListResponse} from "../panels/termsCondition/termsConditionMapper";
import {planListResponse} from "../panels/plan/planMapper";
import {planTypeListResponse} from "../panels/planType/planTypeMapper";
import {promotionListResponse} from "../panels/promotion/promotionMapper";
import {discountListResponse} from "../panels/discount/diacountMapper";
import {bulkDiscountListResponse} from "../panels/bulkDiscount/bulkDiacountMapper";
import {planFeaturesListResponse} from "../panels/planFeatures/planFeaturesMapper";
import {eventBannerListResponse} from "../panels/eventBanner/eventBannerMapper";
import {subscriptionListResponse} from "../panels/subscription/subscriptionMapper";

export function getList(resource, params) {
  const {page, perPage} = params.pagination;
  const {field, order} = params.sort;
  let sortKey = field;
  let sortOrder = order;
  if (
    [
      "advice",
      "user",
      "periods",
      "codes",
      "blog",
      "forumCategory",
      "forum",
      "blogCategory",
      "adminUsers",
      "report",
      "specialistCard",
      "specialistComment",
      "invoice",
      "adminLogHistory",
      "message",
      "conversation",
      "attachment",
      "userConversation",
      "specialistSalesReport",
      "specialistTransaction",
      "conversationAd",
      "avatar",
      "experiment",
      "variant",
      "userVariant",
      "childWeek",
      "marketLogin",
      "welcomeModal",
      "termsCondition",
      "plan",
      "planType",
      "promotion",
      "discount",
      "bulkDiscount",
      "planFeatures",
      "eventBanner",
      "subscription"
    ].includes(resource) &&
    sortKey === "id"
  ) {
    sortKey = "objectId";
  }
  if (["specialistCard", "specialistComment", "invoice", "specialistTransaction"].includes(resource) && sortKey === "objectId") {
    sortKey = "createdAt";
    sortOrder = "DESC";
  }
  const query = {
    range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
    sort: JSON.stringify([sortKey, sortOrder]),
    from: JSON.stringify((page - 1) * perPage),
    to: JSON.stringify(page * perPage - 1),
    filter: JSON.stringify(params.filter),
    phoneNumber: params.filter.phoneNumber,
  };
  const url = `${SERVER}/${MAP_URL[resource]}?${stringify(query)}`;

  return HttpClient(url).then(({headers, json}) => {
    if (resource === "advice") {
      return adviceListResponse(json, headers);
    } else if (resource === "blogCategory") {
      return blogCategoryMapperListResponse(json, headers);
    } else if (resource === "blog") {
      return blogMapperListResponse(json, headers);
    } else if (resource === "user") {
      return userMapperListResponse(json, headers);
    } else if (resource === "config") {
      return configMapperListResponse(json, headers);
    } else if (resource === "periods") {
      return periodMapperListResponse(json, headers);
    } else if (resource === "codes") {
      return codesMapperListResponse(json, headers);
    } else if (resource === "forumCategory") {
      return forumCategoryMapperListResponse(json, headers);
    } else if (resource === "forum") {
      return forumMapperListResponse(json, headers);
    } else if (resource === "report") {
      return reportMapperListResponse(json, headers);
    } else if (resource === "specialistCard") {
      return specialistCardMapperListResponse(json, headers);
    } else if (resource === "specialistComment") {
      return specialistCommentListResponse(json, headers);
    } else if (resource === "invoice") {
      return invoiceMapperListResponse(json, headers);
    } else if (resource === "adminLogHistory") {
      return adminLogHistoryMapperListResponse(json, headers);
    } else if (resource === "userConversation") {
      return userConversationListResponse(json, headers);
    } else if (resource === "attachment") {
      return attachmentMapperListResponse(json, headers);
    } else if (resource === "conversation") {
      return conversationMapperListResponse(json, headers);
    } else if (resource === "message") {
      return messageMapperListResponse(json, headers);
    } else if (resource === "specialistSalesReport") {
      return specialistSalesReportListResponse(json, headers);
    } else if (resource === "specialistTransaction") {
      return specialistTransactionListResponse(json, headers);
    } else if (resource === "conversationAd") {
      return conversationAdMapperListResponse(json, headers);
    } else if (resource === "avatar") {
      return avatarMapperListResponse(json, headers);
    } else if (resource === "experiment") {
      return experimentMapperListResponse(json, headers);
    } else if (resource === "variant") {
      return variantMapperListResponse(json, headers);
    } else if (resource === "userVariant") {
      return userVariantMapperListResponse(json, headers);
    } else if (resource === "childWeek") {
      return childWeekMapperListResponse(json, headers);
    } else if (resource === "marketLogin") {
      return marketLoginListResponse(json, headers);
    } else if (resource === "termsCondition") {
        return termsConditionListResponse(json, headers);
    } else if (resource === "welcomeModal") {
        return welcomeModalListResponse(json, headers);
    } else if (resource === "plan") {
        return planListResponse(json, headers);
    } else if (resource === "planType") {
        return planTypeListResponse(json, headers);
    } else if (resource === "promotion") {
        return promotionListResponse(json, headers);
    } else if (resource === "discount") {
        return discountListResponse(json, headers);
    } else if (resource === "bulkDiscount") {
        return bulkDiscountListResponse(json, headers);
    } else if (resource === "planFeatures") {
        return planFeaturesListResponse(json, headers);
    } else if (resource === "eventBanner") {
        return eventBannerListResponse(json, headers);
    } else if (resource === "subscription") {
        return subscriptionListResponse(json, headers);
    }

    return {
      data: json.map((resource) => ({
        ...resource,
        id: resource.phoneNumber,
      })),
      total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
    };
  });
}
